<template>
  <div class="flex items-center">
    <p class="mr-2 leading-[40px]">{{ title }}</p>
    <div v-if="description" class="flex items-center relative">
      <IconInfo
        class="cursor-pointer w-[20px] h-[20px]"
        @mouseenter="handleShowTip"
        @mouseleave="handleHideTip"
      />
      <transition
        enter-active-class="duration-300 ease-out"
        enter-from-class="transform opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="duration-200 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="transform opacity-0"
        mode="out-in"
      >
        <div
          v-if="showTip"
          class="flex items-center ml-2 p-2 bg-gray-200 shadow absolute rounded w-max left-[25px] z-10 max-w-[300px] h-[40px]"
        >
          <div
            class="w-2 h-2 bg-gray-200 absolute left-[-5px] top-1/2 translate-y-[-50%] rotate-45"
          ></div>
          <p class="normal-case">{{ description }}</p>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import IconInfo from "@/assets/icons/IconInfo";

export default {
  name: "AttrTitleWithDescription",
  components: { IconInfo },
  data() {
    return {
      showTip: false
    };
  },
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  },
  methods: {
    handleShowTip() {
      this.showTip = true;
    },
    handleHideTip() {
      this.showTip = false;
    }
  }
};
</script>
